import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const BreadCrumbs = ({ links }) => (
  <div className={styles.container} >
    <ul itemScope="" itemType="http://schema.org/BreadcrumbList">
      <li className={styles.item}>
        <Link to={'/'} className={classNames(styles.link, styles.hideOnMobile)}>MyBook — Электронная библиотека</Link>
      </li>

      {links.map((link, index) => (
        <li className={styles.item}
          key={`breadCrumb-${index}`}
          itemProp="itemListElement"
          itemScope=""
          itemType="http://schema.org/ListItem">
          <span
            key={`breadcrumbsLevel${index}`}
            className={links.length - 2 === index ? styles.showOnMobile : styles.hideOnMobile}>
            <span className={classNames('', styles.arrow)} />
            {(index < links.length - 1) && link.url
              ? (
                <Link
                  to={link.url}
                  className={classNames(styles.link, { [styles.linkLast]: index===links.length-1 })}>
                  {link.text}
                </Link>
              )
              : (
                <span className={classNames(styles.link, styles.linkLast)}>
                  {link.text}
                </span>
              )}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

BreadCrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.shape({
          pathname: PropTypes.string.isRequired,
          state: PropTypes.object,
          search: PropTypes.string,
        }),
      ]),
      text: PropTypes.string.isRequired,
    })
  ),
};

BreadCrumbs.defaultProps = {
  links: [],
};

export default BreadCrumbs;
